export const getParentGraphStep = (stepId, graph) => {
  for (const key in graph) {
    const step = graph[key];
    if (step?.exit === stepId) {
      return { id: key, relation: 'exit' };
    }
    if (step?.child === stepId) {
      return { id: key, relation: 'child' };
    }
    if (step?.branches?.includes(stepId)) {
      return { id: key, relation: 'branch', index: step?.branches?.indexOf(stepId) };
    }
  }
};
